@if (error$ | async; as error) {
	<stages-dialog2 #dialog [dialogAriaLabel]="error !== undefined ? (error.titleKey | translate) : null">
		<stages-dialog-header />
		<div class="content slide-container">
			<span class="h1" translate="{{ error?.titleKey }}"></span>
			<div class="panel">
				<p>{{ error?.message }}</p>
			</div>
			<div class="panel">
				<div class="switch-details">
					<span class="h5" translate="details"></span>
					<input id="details" type="checkbox" hidden="hidden" [(ngModel)]="details" (click)="toggleState()" />
					<label for="details" class="switch"></label>
				</div>
			</div>
			<div class="two-slot-slide-panels"
					 [class.files-error-swipe-left]="detailsState === 'left'"
			     [class.files-error-swipe-right]="detailsState === 'right'">
				<div class="slide-panel">
					<img [attr.alt]="'files.backgroundimage' | translate" class="birds" src="img/birds.svg" />
				</div>
				<div class="slide-panel">
					<ul class="list">
						@if (error?.jobDetails) {
							<li class="list-item">
								<div class="label">
									<div class="text">
										<span class="h4" translate="files.error.job.started"></span>
										<p
											translate="files.error.job.info"
											[translateParams]="{
												date: $safeNavigationMigration(error?.jobDetails?.date),
												user: $safeNavigationMigration(error?.jobDetails?.user?.fullname),
											}"
										></p>
									</div>
								</div>
							</li>
						}
						@if (errorDetails$ | async; as errorDetails) {
							@for (detail of errorDetails; track detail) {
								<li class="list-item">
									<div class="label">
										<div class="text">
											<span class="h4" [translate]="$any(detail).key"></span>
											<p>{{ $any(detail).value }}</p>
										</div>
									</div>
								</li>
							}
						}
					</ul>
				</div>
			</div>
		</div>
		<footer>
			<div class="buttons">
				<button class="sm" (click)="dialog.close()" translate="close"></button>
			</div>
		</footer>
	</stages-dialog2>
}
